import { render, staticRenderFns } from "./LexonKanbanDialogTemplate.vue?vue&type=template&id=54634d67&scoped=true&let-data=true&lang=pug"
import script from "./LexonKanbanDialogTemplate.vue?vue&type=script&lang=ts"
export * from "./LexonKanbanDialogTemplate.vue?vue&type=script&lang=ts"
import style0 from "./LexonKanbanDialogTemplate.vue?vue&type=style&index=0&id=54634d67&lang=scss&scoped=true"
import style1 from "./LexonKanbanDialogTemplate.vue?vue&type=style&index=1&id=54634d67&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54634d67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54634d67')) {
      api.createRecord('54634d67', component.options)
    } else {
      api.reload('54634d67', component.options)
    }
    module.hot.accept("./LexonKanbanDialogTemplate.vue?vue&type=template&id=54634d67&scoped=true&let-data=true&lang=pug", function () {
      api.rerender('54634d67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LexonKanban/templates/LexonKanbanDialogTemplate.vue"
export default component.exports